import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=dc01308a"
import script from "./ModalAdd.vue?vue&type=script&lang=js"
export * from "./ModalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports